//This file has been customized from the original

//https://github.com/aAXEe/knockout-bootstrap-toggle
(function(factory) {
    // Module systems magic dance.
  
    if (typeof require === "function" && typeof exports === "object" && typeof module === "object") {
      // CommonJS or Node: hard-coded dependency on "knockout"
      factory(require("knockout"), require("jquery"));
    } else if (typeof define === "function" && define["amd"]) {
      // AMD anonymous module with hard-coded dependency on "knockout"
      define(["knockout", "jquery"], factory);
    } else {
      // <script> tag: use the global `ko` object, attaching a `mapping` property
      factory(ko, jQuery);
    }
  }(function(ko, $) {
    //added viewModel parameter 
    function setBootstrapToggleState(element, value, viewModel) {
      var disabled = $(element).prop('disabled');
      //behavior added 
      if (viewModel.dataOnOff) {
        $(element).bootstrapToggle({
          on: viewModel.dataOnOff,
          off: viewModel.dataOnOff,
          width: viewModel.width,
        });
      }
      else {
        $(element).bootstrapToggle();
      }
      $(element).bootstrapToggle('enable');
      $(element).bootstrapToggle(value ? 'on' : 'off');
      if (disabled)
        $(element).bootstrapToggle('disable');
    }
    ko.bindingHandlers.bootstrapToggle = {
      init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
        //$(element).bootstrapToggle(); //disable from the original
        setBootstrapToggleState(element, ko.utils.unwrapObservable(valueAccessor()), viewModel)
        $(element).on('change', function() {
          valueAccessor()($(this).prop('checked'));
        });
      },
      update: function(element, valueAccessor, allBindingsAccessor, viewModel) {
        var vStatus = $(element).prop('checked');
        var vmStatus = ko.utils.unwrapObservable(valueAccessor());
        if (vStatus != vmStatus) {
          setBootstrapToggleState(element, vmStatus, viewModel);
        }
      }
    };
  
  }));